import { render, staticRenderFns } from "./Bibliotheque.vue?vue&type=template&id=4b2effc2&"
import script from "./Bibliotheque.vue?vue&type=script&lang=js&"
export * from "./Bibliotheque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports